module.exports = __webpack_public_path__ + "static/img/preview-yellow-no-progress-bar.db8c3ec0.png";